module.exports = {"510321001":"梧桐街道","510321002":"青阳街道","510321100":"旭阳镇","510321102":"双石镇","510321107":"鼎新镇","510321110":"乐德镇","510321112":"古文镇","510321113":"河口镇","510321114":"新桥镇","510321115":"正紫镇","510321116":"度佳镇","510321117":"东佳镇","510321118":"长山镇","510321119":"保华镇","510321120":"留佳镇","510321121":"来牟镇","510321122":"双古镇","510321123":"观山镇","510321124":"高山镇","510321125":"东兴镇","510321126":"铁厂镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510321.json
// module id = 2409
// module chunks = 0